/**
 * Amplitude analytics events for the paskal theme.
 *
 * Surface area this script reads on the page:
 *   - body[class="template-{page_type}"]            (set in layout/theme.liquid)
 *   - window.__DRESSX_TRYON_PARAMS                  (set by the DRESSX include
 *                                                    snippet on PDP only -
 *                                                    used for product context)
 *   - window.__DRESSX_SIGNED_IN                     (set by the DRESSX include
 *                                                    snippet, same as above)
 *   - fetch interception                            -> added_to_cart
 *                                                      (POST /cart/add(.js))
 *   - change on select[name^="options["]            -> size_selected (PDP)
 *   - submit/click on form[action^="/account/login"] -> sets sessionStorage flag
 *   - submit with submitter[name="checkout"]        -> checkout_started
 *
 * Requires: window.is_amplitude_enabled, window.amplitude.
 *
 * IMPORTANT: this file must be served as UTF-8. To stay safe across editors
 * that may re-encode source files, all non-ASCII characters in regexes are
 * written as \uXXXX escape sequences.
 */
;(function () {
  var body = document.querySelector('body');
  if (!body) return;
  var bodyData = body.dataset || {};

  // Paskal sets only `body class="template-{page_type}"` (no data-template).
  // Derive `template` from that class so the rest of the logic stays uniform.
  function readTemplate() {
    if (bodyData.template) return bodyData.template;
    var cls = body.className || '';
    var m = cls.match(/(?:^|\s)template-([a-z0-9_-]+)/i);
    return m ? m[1] : '';
  }
  var template = readTemplate();

  // Bump on every meaningful change to this file. Sent on every event so
  // Amplitude can filter / diagnose by script version without inspecting the
  // bundle.
  // 1.0.0 - initial port from amplitude-events-ohpolly.js v1.0.0.
  var EVENTS_VERSION = '1.0.0';

  function ampReady() {
    return !!(window.is_amplitude_enabled && window.amplitude && typeof window.amplitude.track === 'function');
  }

  // Single entry point for tracking. Always injects `version` so every event
  // carries the analytics-script version. Returns true if the event was sent.
  function ampTrack(eventName, props) {
    if (!ampReady()) return false;
    var payload = {};
    if (props && typeof props === 'object') {
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
      }
    }
    payload.version = EVENTS_VERSION;
    try {
      window.amplitude.track(eventName, payload);
      return true;
    } catch (e) {
      try { if (window.console && console.warn) console.warn('[amplitude] track failed:', eventName, e); } catch (_) {}
      return false;
    }
  }

  // Shopify line-item / variant prices are always integer cents (e.g. 38000 -> 380.00).
  // Always divide by 100 so the same price appears across product_viewed,
  // added_to_cart, size_selected and checkout_started.
  function centsToPrice(v) {
    if (v == null || v === '') return null;
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (!isFinite(n)) return null;
    return Math.round(n) / 100;
  }

  // Currency for events that include `price`. Paskal does not render
  // body[data-currency], so we fall back to Shopify's runtime currency.
  function getCurrency(fallback) {
    if (fallback) return fallback;
    if (bodyData.currency) return bodyData.currency;
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return '';
  }

  // Sign-in: paskal does not set body[data-signin], so fall back to the
  // DRESSX include snippet's window.__DRESSX_SIGNED_IN.
  function getSignedIn() {
    if (bodyData.signin === 'true' || bodyData.signin === 'false') {
      return bodyData.signin === 'true';
    }
    try { return !!window.__DRESSX_SIGNED_IN; } catch (e) { return false; }
  }

  // try_on_completed is `true` once the user has finished a try-on in this
  // session. The try-on script sets the sessionStorage flag below when the
  // result loads.
  var TRYON_FLAG_KEY = 'dressx_try_on_completed';
  function hasCompletedTryOn() {
    try { return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'; } catch (e) { return false; }
  }

  // Product context on PDP. Paskal does not render body[data-product-*]
  // attributes, so the canonical source is the DRESSX include snippet's
  // window.__DRESSX_TRYON_PARAMS (the same dict the try-on script reads).
  function getDressxParams() {
    try {
      var p = window.__DRESSX_TRYON_PARAMS;
      if (p && typeof p === 'object') return p;
    } catch (e) {}
    return {};
  }

  // Returns an array of strings (collection titles) or null when nothing is
  // available.
  function getProductCollections() {
    var p = getDressxParams();
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      return p.product_collections;
    }
    var raw = bodyData.productCollections;
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) {}
    }
    return null;
  }

  // page_name derivation. Paskal templates are typed by the {page_type}
  // suffix on body class - normalize the common ones the same way oh-polly's
  // theme.liquid does, so dashboards stay consistent across stores.
  function getPageName() {
    if (bodyData.pageName) return bodyData.pageName;
    if (!template) return 'page';
    if (template === 'index') return 'homepage';
    if (template === 'cart' || template === 'search' || template === 'collection' ||
        template === 'product' || template === 'account') return template;
    return template;
  }

  // ---------- page_view ----------
  ampTrack('page_view', {
    page_name: getPageName(),
    signin: getSignedIn()
  });

  // ---------- cart_viewed ----------
  if (template === 'cart') {
    ampTrack('cart_viewed', {
      signin: getSignedIn(),
      try_on_completed: hasCompletedTryOn()
    });
  }

  // ---------- product_viewed ----------
  if (template === 'product') {
    (function () {
      var p = getDressxParams();
      var price = centsToPrice(typeof p.price === 'number' || typeof p.price === 'string'
        // __DRESSX_TRYON_PARAMS.price is rendered as units (e.g. 380.00), not
        // cents. Multiply by 100 to feed centsToPrice the format it expects.
        ? Math.round(parseFloat(p.price) * 100)
        : null);

      var referrer = typeof document.referrer === 'string' ? document.referrer : '';
      var source = 'direct';
      try {
        if (referrer) {
          var refUrl = new URL(referrer);
          if (refUrl.origin === window.location.origin) {
            var path = (refUrl.pathname || '').toLowerCase();
            if (path.indexOf('/search') !== -1) source = 'search';
            else if (path.indexOf('/cart') !== -1) source = 'cart';
            else if (path.indexOf('/collections/') !== -1) source = 'collection';
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist';
            else if (path.indexOf('/account') !== -1) source = 'account';
            else if (path === '/' || path === '') source = 'home';
            else source = 'other';
          } else source = 'external';
        }
      } catch (e) {}

      var props = { signin: getSignedIn(), try_on_completed: hasCompletedTryOn(), source: source };
      if (p.id != null) props.id = p.id;
      if (p.sku) props.sku = p.sku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      if (p.product_category) props.product_category = p.product_category;
      if (p.product_brand) props.product_brand = p.product_brand;
      var pvCollections = getProductCollections();
      if (pvCollections) props.product_collections = pvCollections;
      ampTrack('product_viewed', props);
    })();
  }

  // ---------- login: set sessionStorage flag on login form submit ----------
  // Catch both native submit and a click on a non-submit button inside the
  // form (form-validation patterns sometimes call form.submit() programmatically,
  // which does not fire the 'submit' event).
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var btn = target.closest('button, input[type="submit"]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var action = String(form.action || form.getAttribute('action') || '');
      var hidden = null;
      try { hidden = form.querySelector('input[name="form_type"]'); } catch (er) {}
      var isLoginForm = action.indexOf('/account/login') !== -1 ||
                        (hidden && hidden.value === 'customer_login');
      if (!isLoginForm) return;
      try { sessionStorage.setItem('loginFormSubmitted', '1'); } catch (err) {}
    },
    true
  );
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form) return;
      var action = String(form.action || form.getAttribute('action') || '');
      if (action.indexOf('/account/login') === -1) return;
      try { sessionStorage.setItem('loginFormSubmitted', '1'); } catch (err) {}
    },
    true
  );

  // ---------- login (account page after redirect) ----------
  if (template === 'account' || (getPageName() || '').indexOf('account') !== -1) {
    var isLoginReferal = null;
    try { isLoginReferal = sessionStorage.getItem('loginFormSubmitted'); } catch (err) {}
    if (isLoginReferal) {
      var sent = ampTrack('login', { status: 'login successful' });
      if (sent) {
        try { sessionStorage.removeItem('loginFormSubmitted'); } catch (err) {}
      }
    }
  }

  // ---------- added_to_cart + email_submitted via fetch interception ----------
  // Standard Shopify endpoints used by paskal's product-form and quick-cart.
  function trackAddedToCart(item, cartCurrency) {
    if (!item) return;
    var price = centsToPrice(item.price);
    var props = {
      signin: getSignedIn(),
      try_on_completed: hasCompletedTryOn()
    };
    if (item.id != null) props.id = item.id;
    if (item.sku != null) props.sku = item.sku;
    if (price != null) {
      props.price = price;
      var curr = getCurrency(cartCurrency);
      if (curr) props.currency = curr;
    }
    if (item.product_type != null) props.product_category = item.product_type;
    if (item.vendor != null) props.product_brand = item.vendor;
    var atcCollections = getProductCollections();
    if (atcCollections) props.product_collections = atcCollections;
    ampTrack('added_to_cart', props);
  }

  (function patchFetch() {
    if (typeof window.fetch !== 'function') return;
    var orig = window.fetch.bind(window);
    var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;

    window.fetch = function (input, init) {
      var urlStr = '';
      try {
        urlStr = typeof input === 'string'
          ? input
          : (input && (input.url || input.href || (input.toString && input.toString()))) || '';
      } catch (e) {}
      var method = String((init && init.method) ||
                          (input && input.method) || 'GET').toUpperCase();
      var isCartAdd = method === 'POST' && CART_ADD_RE.test(urlStr);

      var p = orig.apply(this, arguments);
      if (!isCartAdd) return p;

      return p.then(function (response) {
        try {
          if (isCartAdd && response && response.ok) {
            response.clone().json().then(function (data) {
              if (!data) return;
              // /cart/add returns the line item, /cart/add.js returns either
              // the item directly or { items: [...] }.
              var item = (data && data.items && data.items[0]) || data;
              trackAddedToCart(item, '');
            }).catch(function () {});
          }
        } catch (e) {}
        return response;
      });
    };
  })();

  // ---------- email_submitted (Shopify {% form 'customer' %} newsletter) ----------
  // Paskal renders the footer signup via snippets/newsletter-form.liquid using
  // {% form 'customer' %}, which posts the standard Shopify /contact endpoint.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      var isNewsletter = false;
      try {
        if (form.matches('form.newsletter-form')) isNewsletter = true;
        var typeInput = form.querySelector && form.querySelector('input[name="form_type"]');
        var tagsInput = form.querySelector && form.querySelector('input[name="contact[tags]"]');
        if (typeInput && typeInput.value === 'customer' && tagsInput) isNewsletter = true;
      } catch (er) {}
      if (!isNewsletter) return;
      ampTrack('email_submitted', { description: 'user submitted email' });
    },
    true
  );

  // ---------- checkout_started ----------
  // Cart page / drawer use <button name="checkout"> inside <form action="/cart">.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var submitter = e.submitter;
      var formAction = (form && (form.action || form.getAttribute('action'))) || '';
      var submitterName = submitter
        ? (submitter.name || submitter.getAttribute('name') || '')
        : '';
      var isCheckoutSubmit =
        form && formAction.indexOf('cart') !== -1 && submitterName === 'checkout';
      if (!isCheckoutSubmit) return;
      if (!ampReady()) return;
      e.preventDefault();
      var checkoutUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
        .replace(/\/?$/, '') + '/checkout';
      var cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js';
      fetch(cartUrl)
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var first = items[0];
          var price = centsToPrice(first && first.price);
          var props = { try_on_completed: hasCompletedTryOn() };
          if (first && first.id != null) props.id = first.id;
          if (first && first.sku != null) props.sku = first.sku;
          if (price != null) {
            props.price = price;
            var curr = getCurrency(cart && cart.currency);
            if (curr) props.currency = curr;
          }
          if (first && first.product_type != null) props.product_category = first.product_type;
          if (first && first.vendor != null) props.product_brand = first.vendor;
          ampTrack('checkout_started', props);
          setTimeout(function () { window.location.href = checkoutUrl; }, 150);
        })
        .catch(function () { window.location.href = checkoutUrl; });
    },
    true
  );

  // ---------- size_selected (PDP) ----------
  // Paskal renders variant pickers as native <select> elements:
  //   <select id="option{N}" name="options[{option name}]" class="input ...">
  // (see snippets/product-block-variant-picker.liquid). The custom UI
  // (.product__color-swatch, .product__chip) updates this select via change
  // events, so a single `change` listener on the select catches every entry
  // point including programmatic variant swaps.
  if (template === 'product' || template.indexOf('product') !== -1) {
    // size, sizes, taille, tailles, talla, tallas, tamanho, tamanhos,
    // gr\u00f6\u00dfe, gr\u00f6ssen,
    // misura, misure,
    // \u0440\u043e\u0437\u043c\u0456\u0440, \u0440\u043e\u0437\u043c\u0456\u0440\u0438,  (UK rozmir / sizes)
    // \u0440\u0430\u0437\u043c\u0435\u0440, \u0440\u0430\u0437\u043c\u0435\u0440\u044b,
    // \u30b5\u30a4\u30ba,
    // \uce58\uc218,
    // \u5c3a\u7801, \u5c3a\u5bf8
    var SIZE_LABEL_RE = new RegExp(
      '^(' +
        'size|sizes|' +
        'taille|tailles|' +
        'talla|tallas|' +
        'tamanho|tamanhos|' +
        'gr[o\u00f6]sse|gr[o\u00f6]ssen|gr\u00f6\u00dfe|' +
        'misura|misure|' +
        '\u0440\u043e\u0437\u043c\u0456\u0440|\u0440\u043e\u0437\u043c\u0456\u0440\u0438|' +
        '\u0440\u0430\u0437\u043c\u0435\u0440|\u0440\u0430\u0437\u043c\u0435\u0440\u044b|' +
        '\u30b5\u30a4\u30ba|' +
        '\uce58\uc218|' +
        '\u5c3a\u7801|\u5c3a\u5bf8' +
      ')$',
      'i'
    );

    function isSizeSelect(select) {
      if (!select) return false;
      var name = select.getAttribute('name') || '';
      var m = name.match(/^options\[(.+?)\]$/i);
      if (!m) return false;
      var optionName = m[1];
      try { optionName = decodeURIComponent(optionName); } catch (e) {}
      return SIZE_LABEL_RE.test(optionName);
    }

    function findVariantForCurrentSelection(select) {
      try {
        // Paskal renders the full product as <script type="application/json"
        // id="ProductJson-{section.id}"> (see sections/main-product--default.liquid)
        var scope = select.closest('form, .product, [data-product]') || document;
        var jsonEl = document.querySelector('script[id^="ProductJson-"]');
        if (!jsonEl) return null;
        var product = JSON.parse(jsonEl.textContent || '{}');
        if (!product || !Array.isArray(product.variants)) return null;
        var sels = (scope.querySelectorAll && scope.querySelectorAll('select[name^="options["]')) ||
                   document.querySelectorAll('select[name^="options["]');
        var optionVals = [];
        for (var i = 0; i < sels.length; i++) {
          var v = sels[i].value;
          if (!v) return null;
          optionVals.push(v);
        }
        var title = optionVals.join(' / ');
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j] && product.variants[j].title === title) return product.variants[j];
        }
      } catch (e) {}
      return null;
    }

    // Debounce: paskal may dispatch the native `change` for the primary PDP
    // select and a quickbuy / quick-view select on the same logical click.
    // Dedup by (select, value) within a short window.
    var _lastSizeFire = { sel: null, value: '', at: 0 };
    function handleSizeSelect(select) {
      if (!isSizeSelect(select)) return;
      var v = select.value;
      if (!v) return;
      var now = Date.now();
      if (
        _lastSizeFire.sel === select &&
        _lastSizeFire.value === v &&
        now - _lastSizeFire.at < 400
      ) return;
      _lastSizeFire = { sel: select, value: v, at: now };
      var variant = findVariantForCurrentSelection(select);
      var price = variant ? centsToPrice(variant.price) : null;
      var props = { try_on_completed: hasCompletedTryOn() };
      if (variant && variant.id != null) props.id = variant.id;
      if (variant && variant.sku != null) props.sku = variant.sku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      var p = getDressxParams();
      if (p.product_category) props.product_category = p.product_category;
      if (p.product_brand) props.product_brand = p.product_brand;
      var ssCollections = getProductCollections();
      if (ssCollections) props.product_collections = ssCollections;
      ampTrack('size_selected', props);
    }

    function bindSizeSelects() {
      var sels = document.querySelectorAll('select[name^="options["]');
      for (var i = 0; i < sels.length; i++) {
        var sel = sels[i];
        if (sel.__amp_size_bound) continue;
        sel.__amp_size_bound = true;
        sel.addEventListener('change', function (ev) { handleSizeSelect(ev.target); });
      }
    }
    bindSizeSelects();
    // Variant pickers may be re-rendered on color change / async section
    // updates, so retry binding for a short while to pick up new selects.
    var _bindAttempts = 0;
    var _bindTimer = setInterval(function () {
      _bindAttempts++;
      bindSizeSelects();
      if (_bindAttempts >= 10) clearInterval(_bindTimer);
    }, 500);
  }
})();
